import {
  GET_CARRIER_LIST,
  GET_CARRIER_LIST_SUCCESS,
  SET_CARRIER_LIST_LOADING,
  GET_CARRIER_DETAILS,
  GET_CARRIER_DETAILS_ERROR,
  GET_CARRIER_DETAILS_SUCCESS,
  GET_CARRIER_DETAILS_WITH_BUSES_AND_DRIVERS,
  SET_CARRIER_DETAILS_LOADING,
  RESET_CARRIER_DETAILS,
  CREATE_CARRIER,
  CREATE_CARRIER_SUCCESS,
  UPDATE_CARRIER_DETAILS,
  UPDATE_CARRIER_DETAILS_SUCCESS,
  REMOVE_CARRIER,
  REMOVE_CARRIER_SUCCESS,
  RESET_CARRIER_LIST,
  UPDATE_CARRIER_FAILURE,
} from '../constants/ActionTypes';

export const setCarrierListLoading = (isLoading = false) => ({
  type: SET_CARRIER_LIST_LOADING,
  payload: { isLoading },
});

export const getCarrierList = (pageNumber = 1, size) => ({
  type: GET_CARRIER_LIST,
  payload: { pageNumber, size },
});

export const getCarrierListSuccess = (carriers, pageCount) => ({
  type: GET_CARRIER_LIST_SUCCESS,
  payload: { carriers, pageCount },
});

export const setCarrierDetailsLoading = (isLoading = false) => ({
  type: SET_CARRIER_DETAILS_LOADING,
  payload: { isLoading },
});

export const getCarrierDetails = carrierId => ({
  type: GET_CARRIER_DETAILS,
  payload: { carrierId },
});

export const getCarrierDetailsError = () => ({
  type: GET_CARRIER_DETAILS_ERROR,
});

export const getCarrierDetailsSuccess = carrier => ({
  type: GET_CARRIER_DETAILS_SUCCESS,
  payload: { carrier },
});

export const getCarrierDetailsWithBusesAndDrivers = carrierId => ({
  type: GET_CARRIER_DETAILS_WITH_BUSES_AND_DRIVERS,
  payload: { carrierId },
});

export const resetCarrierDetails = () => ({
  type: RESET_CARRIER_DETAILS,
});

export const createCarrier = carrier => ({
  type: CREATE_CARRIER,
  payload: { carrier },
});

export const createCarrierSuccess = carrier => ({
  type: CREATE_CARRIER_SUCCESS,
  payload: { carrier },
});

export const updateCarrierDetails = (carrierId, carrier) => ({
  type: UPDATE_CARRIER_DETAILS,
  payload: { carrierId, carrier },
});

export const updateCarrierDetailsSuccess = carrier => ({
  type: UPDATE_CARRIER_DETAILS_SUCCESS,
  payload: { carrier },
});

export const updateCarrierFailure = () => ({
  type: UPDATE_CARRIER_FAILURE,
});

export const removeCarrier = carrierId => ({
  type: REMOVE_CARRIER,
  payload: { carrierId },
});

export const removeCarrierSuccess = carrierId => ({
  type: REMOVE_CARRIER_SUCCESS,
  payload: { carrierId },
});

export const resetCarrierList = () => ({
  type: RESET_CARRIER_LIST,
});
